import { SpinResponse } from '@cgs/data-access';
import { Container, IntervalAction } from '@cgs/wge';
import { StopAction } from '../../reels_engine/actions/stop_action';
import { StopAfterRespinAction } from '../../reels_engine/actions/stop_after_respin_action';
import {
  GAME_STATE_MACHINE_PROVIDER_TOKEN,
  IGameStateMachineProvider,
} from '../../reels_engine/game_components_providers/i_game_state_machine_provider';
import { IReelsEngineProvider } from '../../reels_engine/game_components_providers/i_reels_engine_provider';
import { ISlotGameEngineProvider } from '../../reels_engine/game_components_providers/i_slot_game_engine_provider';
import { AbstractGameConfig } from '../../reels_engine/game_config/abstract_game_config';
import { ReelsEngine } from '../../reels_engine/reels_engine';
import { RegularSpinsSoundModel } from '../../reels_engine/reels_sound_model';
import { GameStateMachine } from '../../reels_engine/state_machine/game-state-machine';
import {
  T_IGameConfigProvider,
  T_ISlotGameEngineProvider,
  T_RegularSpinsSoundModelComponent,
} from '../../type_definitions';
import { SpinMode } from './i_start_slot_action_provider';
import { IStopSlotActionProvider } from './i_stop_slot_action_provider';
import { IGameConfigProvider } from './interfaces/i_game_config_provider';
import { RegularSpinsSoundModelComponent } from './regular_spins_sound_model_component';

export class StopActionComponent implements IStopSlotActionProvider {
  private readonly _container: Container;
  private readonly _reelsEngine: ReelsEngine;
  private readonly _gameConfig: AbstractGameConfig;
  private readonly _regularSpinSoundModel: RegularSpinsSoundModel;
  private readonly _gameStateMachine: GameStateMachine<SpinResponse>;
  private readonly _stopReelsSoundImmediately: boolean;
  private readonly _useSounds: boolean;

  constructor(container: Container, stopReelsSoundImmediately: boolean, useSounds: boolean = true) {
    this._container = container;
    this._stopReelsSoundImmediately = stopReelsSoundImmediately;
    this._useSounds = useSounds;
    this._gameStateMachine = this._container.resolve<IGameStateMachineProvider>(
      GAME_STATE_MACHINE_PROVIDER_TOKEN
    ).gameStateMachine;
    this._reelsEngine = (
      this._container.resolve<ISlotGameEngineProvider>(
        T_ISlotGameEngineProvider
      ) as IReelsEngineProvider
    ).reelsEngine;
    this._gameConfig =
      this._container.resolve<IGameConfigProvider>(T_IGameConfigProvider).gameConfig;
    this._regularSpinSoundModel = this._container.resolve<RegularSpinsSoundModelComponent>(
      T_RegularSpinsSoundModelComponent
    ).regularSpinSoundModel;
  }

  public getStopSlotAction(spinMode: SpinMode): IntervalAction {
    switch (spinMode) {
      case SpinMode.Spin:
        return new StopAction(
          this._reelsEngine,
          this._gameStateMachine.curResponse.viewReels,
          this._gameStateMachine.curResponse.winLines,
          this._gameStateMachine.curResponse.winPositions,
          this._gameConfig.regularSpinConfig,
          this._regularSpinSoundModel,
          this._stopReelsSoundImmediately,
          this._useSounds
        );
      case SpinMode.ReSpin:
        return new StopAfterRespinAction(
          this._container,
          this._reelsEngine,
          this._gameConfig.regularSpinConfig,
          this._gameStateMachine.curResponse,
          this._regularSpinSoundModel,
          this._stopReelsSoundImmediately,
          this._useSounds
        );
      default:
        return new StopAction(
          this._reelsEngine,
          this._gameStateMachine.curResponse.viewReels,
          this._gameStateMachine.curResponse.winLines,
          this._gameStateMachine.curResponse.winPositions,
          this._gameConfig.regularSpinConfig,
          this._regularSpinSoundModel,
          this._stopReelsSoundImmediately,
          this._useSounds
        );
    }
  }
}
